import { ChangeEvent } from "react";
import { StateCreator } from "zustand";

export interface SearchSlice {
  searchValue: string;
  focus: boolean;
  blur: boolean;
  setSearchValue: (searchValue: ChangeEvent<HTMLInputElement>) => void;
  setFocus: (value: boolean) => void;
  setBlur: (value: boolean) => void;
  focusHandler: () => void;
  blurHandler: () => void;
}

export const createSearchSlice: StateCreator<SearchSlice> = set => ({
  searchValue: "",
  focus: false,
  blur: true,
  setSearchValue: e => set(() => ({ searchValue: e.target.value })),
  setFocus: (focus: boolean) => set(() => ({ focus })),
  setBlur: (blur: boolean) => set(() => ({ blur })),
  focusHandler: () => set(() => ({ blur: false, focus: true })),
  blurHandler: () => set(() => ({ blur: true, focus: false })),
});
